var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.4893C13.6569 15.4893 15 14.1461 15 12.4893C15 10.8324 13.6569 9.48926 12 9.48926C10.3431 9.48926 9 10.8324 9 12.4893C9 14.1461 10.3431 15.4893 12 15.4893Z",
    stroke: "#787486",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.3692V11.6092C2 10.5692 2.85 9.70919 3.9 9.70919C5.71 9.70919 6.45 8.42919 5.54 6.85919C5.02 5.95919 5.33 4.78919 6.24 4.26919L7.97 3.27919C8.76 2.80919 9.78 3.08919 10.25 3.87919L10.36 4.06919C11.26 5.63919 12.74 5.63919 13.65 4.06919L13.76 3.87919C14.23 3.08919 15.25 2.80919 16.04 3.27919L17.77 4.26919C18.68 4.78919 18.99 5.95919 18.47 6.85919C17.56 8.42919 18.3 9.70919 20.11 9.70919C21.15 9.70919 22.01 10.5592 22.01 11.6092V13.3692C22.01 14.4092 21.16 15.2692 20.11 15.2692C18.3 15.2692 17.56 16.5492 18.47 18.1192C18.99 19.0292 18.68 20.1892 17.77 20.7092L16.04 21.6992C15.25 22.1692 14.23 21.8892 13.76 21.0992L13.65 20.9092C12.75 19.3392 11.27 19.3392 10.36 20.9092L10.25 21.0992C9.78 21.8892 8.76 22.1692 7.97 21.6992L6.24 20.7092C5.33 20.1892 5.02 19.0192 5.54 18.1192C6.45 16.5492 5.71 15.2692 3.9 15.2692C2.85 15.2692 2 14.4092 2 13.3692Z",
    stroke: "#787486",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.66952bb8407ca0b468e12f611b8f1ad9.svg";
export { ForwardRef as ReactComponent };